import { render, staticRenderFns } from "./TreatmentSelectInput.vue?vue&type=template&id=d1e252ac&scoped=true"
import script from "./TreatmentSelectInput.vue?vue&type=script&lang=ts"
export * from "./TreatmentSelectInput.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentSelectInput.vue?vue&type=style&index=0&id=d1e252ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e252ac",
  null
  
)

export default component.exports